import { render, staticRenderFns } from "./PlcIndex.vue?vue&type=template&id=1112832c&scoped=true"
import script from "./PlcIndex.vue?vue&type=script&lang=js"
export * from "./PlcIndex.vue?vue&type=script&lang=js"
import style0 from "./PlcIndex.vue?vue&type=style&index=0&id=1112832c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112832c",
  null
  
)

export default component.exports